import { render, staticRenderFns } from "./ExpenditureTable.vue?vue&type=template&id=5e9a8828&scoped=true"
import script from "./ExpenditureTable.vue?vue&type=script&lang=js"
export * from "./ExpenditureTable.vue?vue&type=script&lang=js"
import style0 from "./ExpenditureTable.vue?vue&type=style&index=0&id=5e9a8828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9a8828",
  null
  
)

export default component.exports